var map = {
	"./3d.webp": 7507,
	"./bandera.webp": 564,
	"./bordado.webp": 9061,
	"./esculturas.webp": 3885,
	"./fundicion.webp": 193,
	"./grabado.webp": 8237,
	"./joyeria.webp": 8005,
	"./llaveros.webp": 9485,
	"./medallas.webp": 598,
	"./monedas.webp": 5322,
	"./placas.webp": 7874,
	"./promocional.webp": 9896,
	"./reconocimiento.webp": 2511,
	"./sublimacion.webp": 8904,
	"./torneado.webp": 462,
	"./trofeos.webp": 2225
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6312;